import { Component, OnInit } from '@angular/core';
import { AppSubscription, AuthService } from '../../services/auth.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProtuneApiService } from '../../services/protune-api.service';
import { ConfirmationModalComponent } from '../../components/confirmation-modal/confirmation-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { RouterLink } from '@angular/router';
import moment from 'moment';


@Component({
  selector: 'app-profile-management',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterLink],
  templateUrl: './profile-management.component.html',
  styleUrl: './profile-management.component.scss'
})
export class ProfileManagementComponent implements OnInit {
  changingPassword: boolean = false;
  passwordChangeSuccess: boolean = false;
  passwordChangeFailed: boolean = false;
  passwordChangeFailedDetail: string = '';

  subscription: AppSubscription;

  email: string;
  emailOptIn: boolean;
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  hasAIEngineerSubscription: boolean;

  changePasswordForm: FormGroup;

  constructor(private authService: AuthService,
    private apiService: ProtuneApiService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private errorHandler: ErrorHandlerService) { }

  ngOnInit(): void {
    this.authService.getUserInfo()
      .subscribe(userInfo => {
        this.email = userInfo.email;
      });
    

    this.apiService.getEmailOptIn()
      .subscribe({
        next: emailOptIn => this.emailOptIn = emailOptIn,
        error: err => this.errorHandler.handleError('Unable to get email preferences', err.error, err.request, true)
      });

    this.apiService.getSubscriptionInfo()
      .subscribe({
        next: subscription => {
          this.subscription = subscription

          this.hasAIEngineerSubscription = this.subscription?.aiEngineerSubscriptionExpiration != null && moment().isBefore(this.subscription?.aiEngineerSubscriptionExpiration);
        },
        error: err => this.errorHandler.handleError('Unable to get subscription information', err.error, err.req, true)
      });

    this.changePasswordForm = this.fb.group({
      currentPassword: new FormControl<string>('', { validators: [Validators.required] }),
      newPassword: new FormControl<string>('', { validators: [Validators.required] }),
      confirmNewPassword: new FormControl<string>('', { validators: [Validators.required] }),
    }, { validators: this.confirmPasswordValidator });

    this.changePasswordForm.valueChanges
      .subscribe({
        next: () => {
          this.passwordChangeFailed = false;
          this.passwordChangeFailed = false;
        }
      })
  }

  confirmPasswordValidator = (control: AbstractControl): ValidationErrors | null => {
    return control.value.newPassword === control.value.confirmNewPassword ? null : { PasswordNoMatch: true };
  };

  get changePasswordFormControl() {
    return this.changePasswordForm.controls;
  }

  changePassword() {
    if (this.changePasswordForm.valid) {
      let val = this.changePasswordForm.value;
      this.changingPassword = true;
      this.passwordChangeFailed = false;
      this.passwordChangeSuccess = false;

      this.authService.changePassword(val.currentPassword, val.newPassword)
        .subscribe({
          next: () => {
            this.changingPassword = false;
            this.passwordChangeSuccess = true;
            this.changePasswordForm.reset();

          },
          error: (err) => {
            //this.errorHandler.handleError('Unable to change password', err.error, err.request, false);
            this.passwordChangeFailedDetail = err.error?.detail;
            this.changingPassword = false;
            this.passwordChangeSuccess = false;
            this.passwordChangeFailed = true;
          }
        });
    }
  }

  cancelSubscription() {
    const modal = this.modalService.open(ConfirmationModalComponent);
    modal.componentInstance.title = "Confirm Cancellation";
    modal.componentInstance.message = `By cancelling your subscription, you will continue to have access
              to AI Engineer until the subscription period ends. Your subscription will not be automatically renewed and you
              will not be charged for renewel. Are you sure you want to cancel your subscription?`;

    modal.closed.subscribe({
      next: result => {
        if (result === true) {
          this.apiService.cancelSubscription()
            .subscribe({
              next: () => {
                this.subscription.isAIEngineerSubscriptionCancelled = true;
              }
            })
        }
      },
      error: err => this.errorHandler.handleError("Unable to cancel subscription.", err.error, err.request, true)
    });
  }

  updateEmailOptIn() {
    this.apiService.setEmailOptIn(this.emailOptIn)
      .subscribe({
        error: err => this.errorHandler.handleError('Unable to update email preferences', err.error, err.request, true)
      });
  }

  openBillingPortal() {
    this.apiService.getBillingPortalLink()
      .subscribe({
        next: (billingPortal: any) => {
          window.open(billingPortal.url, "_blank");
        },
        error: err => this.errorHandler.handleError("Unabel to open billing portal.", err.error, err.request, true)
      })
  }
  
}
